import React from 'react'
import Navbar from '../Navbar/Navbar'
import HeroSection from '../HeroSection/HeroSection'
import FeaturesSection from '../FeaturesSection/FeaturesSection'
import Specializations from '../Specializations/Specializations'
import StatsSection from '../StatsSection/StatsSection'
import AboutSection from '../AboutSection/AboutSection'
import ProcessMap from '../ProcessMap/ProcessMap'
import FooterSection from '../FooterSection/FooterSection'
import ProceduresSection from '../ProceduresSection/ProceduresSection'

function HomePage() {
  return (
    <div>
        <Navbar/> 
        <HeroSection/>
        <AboutSection/>
        <FeaturesSection/>
        <Specializations/>
        <ProceduresSection/>
        <StatsSection/>
        <ProcessMap/>
        <FooterSection/>
    </div>
  )
}

export default HomePage